var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 76,
    viewBox: "0 0 83 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C2C2C2",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 10H26a7 7 0 0 0-7 7v50a7 7 0 0 0 7 7h34c7.18 0 13-5.82 13-13V17a7 7 0 0 0-7-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.288 66.276C77.36 64.505 81 59.677 81 54V10a8 8 0 0 0-8-8H41a8 8 0 0 0-8 8v1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinejoin: "round",
    d: "M46 58H2v2c0 7.732 6.268 14 14 14h44c-7.732 0-14-6.268-14-14v-2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtract);
export default __webpack_public_path__ + "static/media/extract.597019e908e801135eca8bf5253f4a93.svg";
export { ForwardRef as ReactComponent };